import { Navigate, Outlet, useParams } from 'react-router-dom';

import { useAppSelector } from '@/hooks/redux-helpers';

import { DashboardHelpers } from '@/utils/DashboardHelpers';

export const Profiles = () => {
  const { userId } = useParams();

  const profiles = useAppSelector((state) => state.profile.profiles.state, {
    devModeChecks: { stabilityCheck: 'never' },
  });

  if (!userId && profiles[0]?.state?.user?.state?.userId)
    return <Navigate to={DashboardHelpers.generateProfilePath(profiles[0]?.state?.user?.state?.userId)} />;

  return (
    <div className="px-6 py-4">
      <Outlet />
    </div>
  );
};
